import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {User, UserRole} from "../../models/user";
import {Subscription} from "rxjs";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {UtilService} from "../../services/util.service";
import {StateService} from "../../services/state.service";
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
import {SidebarService} from "../../services/sidebar.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {AttorneyInfoResponse, FileInfo, WholeDocInfo} from "../../models/docket";
import {CaseDocketService} from "../../services/case-docket.service";
import {EditControlsComponent} from "../edit-controls/edit-controls.component";
import {Agencies} from "../../models/agencies";
import {AgencySelectionComponent} from "../agency-selection/agency-selection.component";
import {NgModel} from "@angular/forms";
import {MatSelectChange} from "@angular/material/select";
import {ProtestInfo} from "../../models/protest";


@Component({
    selector: 'app-case-docketsheet',
    templateUrl: './case-docketsheet.component.html',
    styleUrls: ['./case-docketsheet.component.scss'],
    standalone: false
})
export class CaseDocketsheetComponent implements OnInit, AfterViewInit, OnDestroy {
  UserRole: typeof UserRole = UserRole;

  @ViewChild(MatTable) table!: MatTable<FileInfo>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(AgencySelectionComponent, { static: false }) agencySelection!: AgencySelectionComponent;
  @ViewChild('bNumber', { static: false }) bNumber!: NgModel;
  @ViewChild('dmNumber', { static: false }) dmNumber!: NgModel;

  dataSource = new MatTableDataSource<FileInfo>();
  private a_No!: string;
  public isPo!: boolean;
  displayedColumns = ['indexNum', 'fileAlert', 'docTypeName', 'submitter_Role', 'is_Confidential',
    'transient_Time', 'transient_Note', 'attorney_Note'];
  public docketResponse!: AttorneyInfoResponse;
  updateProtectiveOrderForm: any;
  editDMNumForm: any;
  verifyDm: boolean | undefined;

  docketSub!: Subscription;
  emailSub!: Subscription;
  completeSub!: Subscription;

  attorneyGroups: number[] = [];
  attorneysByGroup = new Map<number, User[]>();
  docTypeGroups: string[] = [];
  docTypesByGroup = new Map<string, WholeDocInfo[]>();

  selectedCaseType?: string;
  selectedCompanyStatus?: string;
  selectedCaseStatus?: string;
  selectedPOOption?: string;
  selectedAgencies?: Agencies;
  selectedProtestor?: string;
  selectedBnumber?: string;
  selectedSolicitationNumber?: string;
  selectedAttorney?: User;
  selectedAttorneyId?: string;
  selectedAttorneyGroupId?: number;
  selectedDocType: WholeDocInfo[] = [];
  selectedDocTypeId: number[] = [];
  selectedDMNumber?: string;

  caseTypes = [ {
    value : 'PROTEST',
    text : 'PROTEST'
  },{
    value : 'SUPPLEMENTAL',
    text : 'SUPPLEMENTAL'
  }, {
    value : 'RECONSIDERATION',
    text : 'RECONSIDERATION'
  }, {
    value : 'ENTITLEMENT',
    text : 'ENTITLEMENT'
  }, {
    value : 'COST-CLAIM',
    text : 'COST-CLAIM'
  }];

  companyStatuses = [ {
    value : 'SMALL',
    text : 'SMALL'
  },{
    value : 'LARGE',
    text : 'LARGE'
  }];

  caseStatuses = [ {
    value : 'OPEN',
    text : 'OPEN'
  }, {
    value : 'CLOSED',
    text : 'CLOSED'
  }];

  protectiveOrderOptions = [ {
    value : 'Y',
    text : 'Y'
  }, {
    value : 'N',
    text : 'N'
  }];

  dateWidth = "96px";

  constructor(public util: UtilService,
              public stateService: StateService,
              private activatedRoute: ActivatedRoute,
              private sidebarService : SidebarService,
              private caseDocketService: CaseDocketService,
              private router: Router,
              private elem: ElementRef) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.docketResponse = undefined!;
      this.a_No = params['a_No'];
      this.caseDocketService.loadDocket(this.a_No, true);
    })

    this.getListOfAttorneys();
    this.docketSub = this.caseDocketService.docketSub$.subscribe((response: AttorneyInfoResponse|undefined) => {
      if (!response) return;
      this.processCaseDocket(response);
    });

    if (this.stateService.userRole === UserRole.GAO_Admin) {
      this.dateWidth = "144px";  // set the width of date field to allow for edit/pencil
    }
    this.elem.nativeElement.style.setProperty('--docket_date_width', this.dateWidth);
  }

  ngOnDestroy(): void {
    this.docketSub.unsubscribe();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.sortingDataAccessor;
  }

  private processCaseDocket(response: AttorneyInfoResponse): void {
    console.debug(response);

    if (response.caseDocketNotFound) {
      this.util.displayDialogMessage('Error', 'Case does not exist');
      return;
    }

    if (response.protestInfo.caseAccessRequestType){
      this.caseDocketService.checkCaseAccessRequestStatus(response.protestInfo);
      this.router.navigate([this.util.getDashboardURL()] );
      return;
    }

    this.docketResponse = response;
    this.sidebarService.setNavByUser(this.stateService.user.role_id, this.docketResponse.protestInfo);

    if (response.fileInfoList?.length) {
      let isDeleted = response.protestInfo.caseCompletionStatus.isDeleted;
      const filteredFileList = response.fileInfoList.reduce((acc: FileInfo[], fileInfo) => {
        fileInfo.sortableSubmissionDate = new Date(fileInfo.originalSubmissionDate);
        // Unique values based on originalSubmissionDate - Skip case closeout (158) if case is deleted
        let idx = acc.findIndex(file => file.originalSubmissionDate === fileInfo.originalSubmissionDate);
        if (idx == -1 && (!isDeleted || (isDeleted && fileInfo.doc_Type_Id != 158))) {
          acc.push(fileInfo);
        }

        return acc;
      }, []);

      filteredFileList.sort((a, b) => {
        return a.sortableSubmissionDate < b.sortableSubmissionDate ? -1 : 1;
      });

      response.fileInfoList = filteredFileList;

      this.selectedDocType = new Array(response.fileInfoList.length)
      this.selectedDocTypeId = new Array<number>(response.fileInfoList.length);
    }

    this.isPo = this.docketResponse.protestInfo.po == 'Y';
    // need to add the index in the data for index sort
    response.fileInfoList.forEach((file, i) => {
        file.indexNum = i+1;
    });
    this.dataSource.data = response.fileInfoList;

    this.docketResponse.intervenorCompanyNameList = this.docketResponse.intervenorCompanyNameList.filter((name) => {
      return name != null;
    });

    if (response.protestInfo?.public_decision_date) {
      const today = new Date();
      const decisionDate = new Date(response.protestInfo.public_decision_date);
      const diffInTime = today.getTime() - decisionDate.getTime();
      const daysPassed= Math.round(diffInTime / (1000 * 3600 * 24));

      if (daysPassed > 60 && (response.protestInfo && response.protestInfo.role.trim().indexOf("GAO") > -1)) {
        response.protestInfo.case_Status = 'PUBLIC DECISION +60 DAYS';

        if (response.protestInfo.caseCompletionStatus.isZipCreated === true &&
            response.protestInfo.caseCompletionStatus.isDmEntered === true) {
          response.protestInfo.case_Status = 'READY TO COMPLETE';
        }

        if (response.protestInfo.caseCompletionStatus.isZipCreated === true &&
            response.protestInfo.caseCompletionStatus.isDmEntered === true &&
            response.protestInfo.caseCompletionStatus.isDmVerfied === true ) {
          response.protestInfo.case_Status = 'COMPLETE';
        }
      }

    }

    this.processDocList();
  }

  getListOfAttorneys() {
    if (this.stateService.userRole === UserRole.GAO_Admin) {
      this.caseDocketService.getListOfAttorneys().subscribe(attorneyUserList => {
        const attorneyList = attorneyUserList.gao_User_Info_List;

        if (attorneyList) {
          attorneyList.forEach(attorney => {
            if (this.attorneyGroups.indexOf(+attorney.group_No) === -1) {
              this.attorneyGroups.push(+attorney.group_No);
            }
          });

          this.attorneyGroups = this.attorneyGroups.sort();

          this.attorneyGroups.forEach(group => {
            this.attorneysByGroup.set(group, []);
          })

          attorneyList.forEach(attorney => {
            const attorneyGroup = this.attorneysByGroup.get(+attorney.group_No) || [];
            attorneyGroup.push(attorney);
          });
        }
      });
    }
  }

  processDocList() {
    this.docTypeGroups = [];
    this.docTypesByGroup = new Map<string, WholeDocInfo[]>();
    const docTypesForCaseType = this.docketResponse.whole_Doc_Info_Map.filter(item => item.case_Type === this.docketResponse.protestInfo.case_Type || item.case_Type === 'ALL');

    if (docTypesForCaseType) {
      docTypesForCaseType.forEach(item => {
        if (this.docTypeGroups.indexOf(item.role) === -1) {
          this.docTypeGroups.push(item.role);
        }
      });

      this.docTypeGroups = this.docTypeGroups.sort();

      docTypesForCaseType.forEach(item => {
        const docsByCaseTypes = this.docTypesByGroup.get(item.role) || [];
        docsByCaseTypes.push(item);
        this.docTypesByGroup.set(item.role, docsByCaseTypes);
      })

      // Sort items by filing order withing the group
      this.docTypesByGroup.forEach((list, key) => {
        const sortedListByFiling = list.sort((a, b) => {
          if (a.filing_Order === b.filing_Order) {
            return 0;
          } else if (a.filing_Order === null) {
            return 1;
          } else if (b.filing_Order === null) {
            return -1;
          } else {
            return  a.filing_Order - b.filing_Order;
          }
        });

        this.docTypesByGroup.set(key, sortedListByFiling);
      });

    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value ?? '';
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  redirectToConsolidatedCaseDocketSheet(protest: ProtestInfo) {
    this.caseDocketService.redirectToCaseDocket(protest);
  }

  redirectToCaseDocketFileInfo(a_No: any, originalSubmissionDate: any, doc_Type_Id: any, fileAlert: any, i: any) {
    const navigationExtras: NavigationExtras = { state: { a_No: a_No, originalSubmissionDate: originalSubmissionDate, doc_Type_Id: doc_Type_Id, fileAlert: fileAlert, i: i } };
    this.router.navigate(['/user/docket-document-info'], navigationExtras);
  }

  addComments(fileInfo: FileInfo, file_Id: number, transient_Comment: string) {
    this.util.displayDialogMessage('Edit Comments', 'Comments',
      {cancelBtn:true, getResponse:true, getResponseMax:250, response: transient_Comment}).subscribe((dialogResp) => {
      if (dialogResp?.response) {
        dialogResp.response = this.util.removeCurlyQuotes(dialogResp.response);
        this.caseDocketService.addComments(dialogResp.response, file_Id).subscribe((addResp) => {
          if (addResp) {
            if (addResp.inputErrors) {
              let message = "";
              addResp.inputErrors.forEach(inputErrors => message += inputErrors.invalidValue + ": " + inputErrors.message + '<br>');
              this.util.displayDialogMessage("Input Errors", message);
            } else {
              fileInfo.isCommentEdited = addResp.fileInfoList[0].isCommentEdited;
              fileInfo.transient_Comments = addResp.fileInfoList[0].transient_Comments;
              fileInfo.transient_Comments_Date = addResp.fileInfoList[0].transient_Comments_Date;
              this.util.displayDialogMessage('Success', 'Comments updated');
            }
          } else {
            this.util.displayDialogMessage('Error', 'There was a problem updating the Comment');
          }
        });
      }
    });
  }


  addAttorneyNotes(fileInfo: FileInfo, file_Id: string, transient_Note: string) {
    this.util.displayDialogMessage('Edit GAO Notes', 'GAO Notes',
      {cancelBtn:true, getResponse:true, getResponseMax:250, response: transient_Note}).subscribe((dialogResp) => {
      if (dialogResp?.response) {
        dialogResp.response = this.util.removeCurlyQuotes(dialogResp.response);
        this.caseDocketService.addAttorneyNote(dialogResp.response, file_Id).subscribe((addResp) => {
          if (addResp) {
            if (addResp.inputErrors) {
              let message = "";
              addResp.inputErrors.forEach(inputErrors =>  message += inputErrors.invalidValue + ": " + inputErrors.message + '<br>');
              this.util.displayDialogMessage("Input Errors", message);
            } else {
              fileInfo.isAttorneyNoteEdited = 'Y';
              fileInfo.transient_Note = addResp.addAttorneyNote.note;
              fileInfo.attorney_Note = addResp.note;
              fileInfo.transient_Attorney_Note_Date = addResp.currentTime;
              this.util.displayDialogMessage('Success', 'GAO Note updated');
            }
          } else {
            this.util.displayDialogMessage('Error', 'There was a problem updating the GAO Note');
          }
        });
      }
    });
  }

  splitString(docTypeName: string) {
    return docTypeName.split("_")[0];
  }

  onDownload() {
    // Does not work on angular-cli, needs to be on jboss directly
    window.open(this.util.getBaseURL() + "/epds/download-offline-cds/" + this.a_No, '_blank');
  }

  onFieldSave(aNum: string, groupNo: number|undefined, oldValue: any,  typeOfChange: string, value: any, control: EditControlsComponent) {
    if (value) {
      const agencyTier1 = (typeOfChange === 'Agency Name' && this.selectedAgencies?.tier1Agency.agency_Id) ? this.selectedAgencies?.tier1Agency.agency_Id : undefined;
      const agencyTier2 = (typeOfChange === 'Agency Name' && this.selectedAgencies?.tier2Agency?.agency_Id) ? this.selectedAgencies?.tier2Agency.agency_Id : undefined;
      value = typeOfChange === 'Agency Name' ? this.selectedAgencies?.tier1Agency.agency_Name + (this.selectedAgencies?.tier2Agency ?  "/" + this.selectedAgencies?.tier2Agency?.agency_Name : "") : value;

      this.caseDocketService.updateProtestInfo(aNum, groupNo, oldValue, typeOfChange, value, agencyTier1, agencyTier2).subscribe(result => {
        if (result.isSuccess) {
          this.util.displayDialogMessage("Success", "You have successfully updated " + typeOfChange).subscribe(() => {
            control.editMode = false;

            this.docketResponse.protestInfo = result.protestInfo;

            // Values where server does not return updated value in response
            switch (typeOfChange) {
              case 'Protective Order': {
                this.docketResponse.protestInfo.po = value;
                break;
              }
              case 'Agency Name': {
                this.docketResponse.protestInfo.agency_Name = value;
                break;
              }
              case 'Attorney Info': {
                this.docketResponse.attorneyInfo = this.selectedAttorney
              }
            }

          });
        } else {
          this.util.displayDialogMessage("Error", "There was a problem updating " + typeOfChange);
        }
      });
    }
  }

  onAgencyEdit() {
    setTimeout(() => {
      if (this.agencySelection) {
        const agency = this.docketResponse.protestInfo.agency_Name;
        const agencySeparatorIdx = this.docketResponse.protestInfo.agency_Name.indexOf('/')

        if (agencySeparatorIdx > 0) {
          const agency1 = agency.substring(0, agencySeparatorIdx);
          const agency2 = agency.substring(agencySeparatorIdx + 1);
          this.agencySelection.tier1AgencyName = agency1;
          this.agencySelection.tier2AgencyName = agency2;
        } else {
          this.agencySelection.tier1AgencyName = agency;
        }
      }
    });
  }

  onSelectedAgencies(event: any) {
    this.selectedAgencies = event;
  }

  checkBNumber(control:NgModel) {
    const bNum = control.control.value;

    if (bNum) {
      const leftSide = bNum.split(".")[0];

      if (leftSide) {
        const digits = leftSide.replace(/\D/g, "");

        if (digits?.length < 6) {
          control.control.setErrors({error: "Must be at least 6 digits"})
        }
      }

      if (!bNum.startsWith('B-')) {
        control.control.setErrors({error: "Must start with B-"})
      }

      if (!bNum.split(".")[1]) {
        control.control.setErrors({error: "Must contain decimal digit"})
      }
    }

  }

  onAttorneyEdit() {
    if (this.docketResponse.attorneyInfo) {
      const groupAttorneys = this.attorneysByGroup.get(this.docketResponse.protestInfo.attorney_Group_Id);

      if (groupAttorneys) {
          this.selectedAttorney = groupAttorneys.find((attorney) =>
            attorney.user_Id === this.docketResponse.attorneyInfo?.user_Id
          );
      }
    }
  }

  onAttorneyChange(event: MatSelectChange) {
    const user: User = event.value;
    this.selectedAttorneyId = user.user_Id;
    this.selectedAttorneyGroupId = +user.group_No;
  }

  onAddMinuteEntry() {
    this.util.displayDialogMessage('Add Minute Entry', 'Minute Entry',
      {cancelBtn:true, getResponse:true, getResponseMax:250}).subscribe((dialogResp) => {
      if (dialogResp?.response) {
        dialogResp.response = this.util.removeCurlyQuotes(dialogResp.response);

        this.caseDocketService.addMinuteEntry(this.docketResponse.protestInfo.a_No, dialogResp.response).subscribe((addResp) => {
          if (addResp) {
            if (addResp.inputErrors) {
              let message = "";
              addResp.inputErrors.forEach(inputErrors =>  message += inputErrors.invalidValue + ": " + inputErrors.message + '<br>');
              this.util.displayDialogMessage("Input Errors", message);
            } else {
              this.caseDocketService.loadDocket(this.a_No, true);
              this.util.displayDialogMessage('Success', 'Minute Note Added').subscribe(() => {});
            }
          } else {
            this.util.displayDialogMessage('Error', 'There was a problem adding the Minute Note');
          }
        });
      }

    });

  }

  onDocTypeEdit(fileInfo: FileInfo, index: number) {
    let selectedDocType: WholeDocInfo;

    this.docTypesByGroup.forEach((docType) => {
      if (!selectedDocType) {
        const docTypeByRole = docType.find(item =>  item.doc_Type_Id === fileInfo.doc_Type_Id);

        if (docTypeByRole) {
          selectedDocType = docTypeByRole;
        }
      }
    });

    this.selectedDocType[index] = selectedDocType!;
    this.selectedDocTypeId[index] = this.selectedDocType[index].doc_Type_Id;
  }

  onDocTypeChangeChange(event: MatSelectChange, index: number) {
    const docType: WholeDocInfo = event.value;
    this.selectedDocTypeId[index] = docType.doc_Type_Id;
  }

  onDocTypeSave(aNum: string, fileInfo: FileInfo, docType: WholeDocInfo, control: EditControlsComponent) {
    if (docType) {
      if (docType.doc_Type_Desc.indexOf("_") > -1) {
        this.util.displayDialogMessage(docType.doc_Type_Desc, "Please briefly describe the document " + "you are filing (e.g., objection to agency's 5 day letter, request for an extension).",
          {
            cancelBtn: true,
            confirmText: "OK",
            cancelText : "Cancel",
            confirmButtonColor: "primary",
            cancelButtonColor:"warn",
            getResponse: true,
            getResponseMax: 250
          })
          .subscribe(res => {
            if (res && res.response != undefined) {
              let filler = res.response.replace(/\n/g, '');
              this.changeDocType(aNum, fileInfo, docType, control, filler);
            } else {
              // cancel
              return;
            }
          });
      } else {
        this.changeDocType(aNum, fileInfo, docType, control);
      }
    }
  }

  changeDocType(aNum: string, fileInfo: FileInfo, docType: WholeDocInfo, control: EditControlsComponent, filler?: string) {
    this.caseDocketService.changeTypeOfDocument(aNum, fileInfo.file_Id, docType.doc_Type_Id, fileInfo.doc_Type_Id, filler).subscribe(result => {
      this.util.displayDialogMessage("Success", "You have successfully updated Type of Filing").subscribe(() => {
        control.editMode = false;

        fileInfo.doc_Type_Id = docType.doc_Type_Id;
        fileInfo.docTypeName = docType.doc_Type_Desc;
        fileInfo.filler = filler ? filler : "";
      });

    });
  }


  checkDMNumber(control:NgModel) {
    const dmNumber = control.control.value;

    if (dmNumber) {
      this.caseDocketService.validateDmInfo(this.docketResponse.protestInfo.a_No, dmNumber).subscribe(result => {
        if (result.isExists && (dmNumber !== this.docketResponse.protestInfo.caseCompletionStatus.dmNumber)) {
          control.control.setErrors({error: "DM Number already exists"})
        }
      });

    }
  }

  onDMNumberSave(aNum: string, dmNumber: string|undefined, control: EditControlsComponent) {
    if (dmNumber) {
      this.caseDocketService.updateDmInfo(aNum, dmNumber).subscribe(protestInfo => {
        if (protestInfo) {
          this.util.displayDialogMessage("Success", "You have successfully updated DM Number").subscribe(() => {
            control.editMode = false;

            this.docketResponse.protestInfo.caseCompletionStatus.dmNumber = dmNumber;
          });
        } else {
          this.util.displayDialogMessage('Error', 'There was a problem updating DM Number');
        }
      });
    }

  }

  onCompanyStatusChange() {
    if (this.selectedCompanyStatus) {
      // Fix data issue when lowercase in db
      if (this.selectedCompanyStatus !== this.selectedCompanyStatus.toUpperCase()) {
        this.selectedCompanyStatus = this.selectedCompanyStatus.toUpperCase();
      }
    }
  }

  onUpdateSubmissionDate(fileInfo: FileInfo) {
    console.log(fileInfo);
    this.util.displayDialogMessage('Edit Date', 'Date',
      {cancelBtn:true, getResponse:true, response: fileInfo.submission_Date}).subscribe((dialogResp) => {
      if (dialogResp?.response) {
        dialogResp.response = this.util.removeCurlyQuotes(dialogResp.response.trim());
        if (dialogResp.response.length !=24) {
          this.util.displayDialogMessage('Error', 'Date length changed, retry edit');
          return;
        }
        const formData = { file_Id: fileInfo.file_Id, newValue: dialogResp.response };
        this.caseDocketService.changeFileAttribute(formData, 'Submission date').subscribe((addResp) => {
          if (addResp) {
            if (addResp.inputErrors) {
              let message = "";
              addResp.inputErrors.forEach(inputErrors =>  message += inputErrors.invalidValue + ": " + inputErrors.message + '<br>');
              this.util.displayDialogMessage("Input Errors", message);
            } else {
              fileInfo.transient_Date = addResp.fileInfoList[0].transient_Date;
              fileInfo.transient_Time = addResp.fileInfoList[0].transient_Time;
              fileInfo.submission_Date = addResp.fileInfoList[0].submission_Date;
              this.util.displayDialogMessage('Success', 'Date updated');
            }
          } else {
            this.util.displayDialogMessage('Error', 'There was a problem updating the Date');
          }
        });
      }
    });
  }
}
